/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import CampaignModel from 'cio/models/campaign';
import { ConditionEditorSubLayout } from 'cio/utils/condition-editor';

interface ConditionListEventEditorComponentArgs {
  condition: any;
  campaign?: CampaignModel;
  variation?: string;
  gapSize?: string;
  subLayout?: ConditionEditorSubLayout;
  direction?: string;
  size?: string;
  dropdownClass?: string;
  marginClass?: string;
  allowForeignEvent?: boolean;
  disableForeignEvent?: boolean;
  allowJsonOperators?: boolean;
  hiddenInverseOptions?: string[];
  disabled?: boolean;
}

export default class ConditionListEventEditorComponent extends Component<ConditionListEventEditorComponentArgs> {
  get hasFilters() {
    return this.args.condition.filters.length > 0;
  }

  get disabledInverseOptions() {
    if (this.args.disableForeignEvent ?? false) {
      return ['foreign_event'];
    }

    return [];
  }

  @action
  addFilter() {
    let condition = EventAttributeCondition.create({
      event: this.args.condition.name,
      name: '',
      operator: 'eq',
      value: '',
      isForeignEventFilterAttribute: this.args.condition.isForeignEvent,
    });
    this.args.condition.set('filters', [...this.args.condition.filters, condition]);
  }

  @action
  removeFilter(index: number) {
    this.args.condition.set(
      'filters',
      this.args.condition.filters.filter((_: any, i: number) => i !== index),
    );
  }
}
